import { types as userTypes, selectors as userSelectors } from "../user";
import { setItem, savePersist } from "../../ui/utils/data";

/**
 * The non-redux bits of fraction are causing a lot of issues
 * when they're not cleaned up appropriately.  This is a way
 * to do some of that cleanup based on certain triggered events.
 * Hopefully, eventually, we can do away with this.
 */
export default store => next => action => {
  if (action.type === userTypes.USER_SIGNED_OUT) {
    // clear booklist
    setItem("fraction_data_bl", JSON.stringify({}));
    setItem("fraction_data_bl_fin", JSON.stringify({}));

    // We don't clear redirects here because this gets called
    // on every 401 from jigsaw which clears them relentlessly.
    // Right now we clear on the signOut action instead (but maybe
    // we could check if the user exists at this point and only do it then?)

    Fraction.User = undefined;

    // this is essentially replacing a savePersist of _default data in
    // a world where we don't actually use it in redux
    setItem("_default_fraction_data", JSON.stringify({}));
  }
  next(action);
};
